import { render, staticRenderFns } from "./EndorsementContractProducts.vue?vue&type=template&id=5d5f893e"
import script from "./EndorsementContractProducts.vue?vue&type=script&lang=js"
export * from "./EndorsementContractProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports